import { render, staticRenderFns } from "./age-in-graph.vue?vue&type=template&id=79124f2a&scoped=true&"
import script from "./age-in-graph.vue?vue&type=script&lang=js&"
export * from "./age-in-graph.vue?vue&type=script&lang=js&"
import style0 from "./age-in-graph.vue?vue&type=style&index=0&id=79124f2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79124f2a",
  null
  
)

export default component.exports